import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, RowsSkeletonLoader } from '@node-space/ui-components'
import { RequestErrorStatusCard } from 'components/Errors/RequestErrorStatusCard'
import { SidePanelSection } from 'components/SidePanel/SidePanelSection'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { CustomerApplicationDetails } from 'types/customers'

interface CustomerInfoRequiredProps {
  data: CustomerApplicationDetails | undefined
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

export const CustomerInfoRequired = ({
  data,
  isLoading,
  isError,
  refetch,
}: CustomerInfoRequiredProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return <RowsSkeletonLoader rows={MIN_PAGINATION_SIZE} />
  }

  if (isError) {
    return (
      <Box paddingX={16} paddingY={32}>
        <RequestErrorStatusCard onReload={refetch} />
      </Box>
    )
  }

  const requiredActions = data?.requiredActions

  const uniqueCategoryRows = requiredActions
    ?.filter((item, index, arr) => arr.findIndex(i => i.category === item.category) === index)
    .map(item => ({
      label: t(`customers.infoRequired.categories.${item.category}`, item.category),
      content: '',
    }))

  return (
    <Box flexCol gapY={16} padding={16}>
      {!!uniqueCategoryRows?.length && (
        <SidePanelSection heading={t('customers.infoRequired.details')}>
          <ul className="list-disc pl-5 text-body-regular-small">
            {uniqueCategoryRows.map(({ label }) => (
              <li key={label}>{label}</li>
            ))}
          </ul>
        </SidePanelSection>
      )}
    </Box>
  )
}
